import { render, staticRenderFns } from "./big-image.vue?vue&type=template&id=06a1839e&scoped=true&"
import script from "./big-image.vue?vue&type=script&lang=js&"
export * from "./big-image.vue?vue&type=script&lang=js&"
import style0 from "./big-image.vue?vue&type=style&index=0&id=06a1839e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a1839e",
  null
  
)

export default component.exports